import Vue from "vue";
import Router from "vue-router";
import store from "@/store/";
import newsRoutes from "./news";
import teamsRoutes from "./teams";
import bracketsRoutes from "./brackets";
import profileRoutes from "./profile";
import photosRoutes from "./photos";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,

  scrollBehavior(to, from) {
    if (to.name === from.name) return;
    let target = "body";
    const targetElement = document.querySelector(target);
    if (!targetElement) return;
    targetElement.scrollIntoView({
      behavior: "auto"
    });
  },

  routes: [
    {
      path: "/",
      name: "home",
      meta: {
        layout: "LayoutSidebar"
      },
      component: () =>
        import(/* webpackChunkName: "home" */ "@/views/home/Home")
    },
    {
      path: "/schedule",
      name: "schedule",
      meta: {
        layout: "LayoutSidebar"
      },
      component: () =>
        import(/* webpackChunkName: "schedule" */ "@/views/schedule/Schedule")
    },
    {
      path: "/schedule-iframe",
      name: "schedule-iframe",
      component: () =>
        import(/* webpackChunkName: "schedule" */ "@/views/schedule/Schedule")
    },
    {
      path: "/regulations",
      name: "regulations",
      component: () =>
        import(
          /* webpackChunkName: "regulations" */ "@/views/regulations/Regulations"
        )
    },
    {
      path: "/manual",
      name: "manual",
      meta: {
        layout: "LayoutSidebar"
      },
      component: () =>
        import(/* webpackChunkName: "manual" */ "@/views/manual/Manual")
    },
    {
      path: "/contacts",
      name: "contacts",
      component: () =>
        import(/* webpackChunkName: "contacts" */ "@/views/contacts/Contacts")
    },
    {
      path: "/registration",
      name: "registration",
      component: () =>
        import(
          /* webpackChunkName: "registration" */ "@/views/registration/Registration"
        )
    },
    ...newsRoutes,
    ...teamsRoutes,
    ...bracketsRoutes,
    ...profileRoutes,
    ...photosRoutes,
    {
      path: "/password-reset",
      name: "password-reset",
      component: () =>
        import(/* webpackChunkName: "password-reset" */ "@/views/PasswordReset")
    },
    {
      path: "/404",
      name: "404",
      component: () => import(/* webpackChunkName: "404" */ "@/views/404.vue")
    },
    {
      path: "*",
      redirect: "404"
    }
  ]
});

function ifAuthenticated(to, from, next) {
  if (store.getters["auth/isAuthenticated"]) {
    next();
    return;
  }

  const needAuth = to.matched.some(record => record.meta.requiresAuth);

  if (store.state.auth.status === "loading") {
    const unwatch = store.watch(
      () => store.state.auth.status,
      () => {
        if (!store.getters["auth/isAuthenticated"] && needAuth) {
          next({ name: "home" });
        } else {
          next();
        }
        unwatch();
      }
    );
  } else {
    if (needAuth) {
      next({ name: "home" });
    } else {
      next();
    }
  }
}

router.beforeEach(ifAuthenticated);

export default router;
